import React, { useEffect, useRef, useState } from "react";
import Headeraccount from "../Headeraccount";
import Footer from "../Footer";
import Navigation from "../Navigation";
import {
  Button,
  Checkbox, IconX,
  Search,
  Select,
  Table,
  TextBox,
  ThemeProvider,
} from "@veneer/core";
import EncodingService from "../api/encoding/EncodingService";
import InlineEdit from "../components/InlineEdit.js";
import { showToast } from "../components/Toast";
import { filterSort } from "../common";
import { AUTHENTICATED, removeLocalStorageItem } from "../utils/storage-utils";
import { Pagination } from "@veneer/core";

const SupplyCatalog = (props) => {
  const inputRef1 = useRef();
  const supplyFamilyRef = useRef();
  const targetSupplyRef = useRef();
  const tabsEnabledStatus = "FULL";
  const [supplyFamily, setSupplyFamily] = useState([]);
  const [tableSupplyData, setTableSupplyData] = useState([]);
  const [supplyName, setSupplyName] = useState("");
  const [selectedSupplyFamily, setSelectedSupplyFamily] = useState({});
  const [target, setTarget] = useState("");
  const [errorsupplyName, setErrorSupplyName] = useState(false);
  const [errortarget, setErrorTarget] = useState(false);
  const [selectFamilyError, setSelectFamilyError] = useState(false);
  const [currentSupplyFamilyPage, setCurrentSupplyFamilyPage] = useState(1);
  const [supplyFamilyPageSize, setSupplyFamilyPageSize] = useState(10);
  const [currentTableSupplyDataPage, setCurrentTableSupplyDataPage] = useState(1);
  const [tableSupplyDataPageSize, setTableSupplyDataPageSize] = useState(10);
  const [currentSupplyFamilyDataLoading, setCurrentSupplyFamilyDataLoading] = useState(true);
  const [currentSupplyDataLoading, setCurrentSupplyDataLoading] = useState(true);
  const [changeFamilyValue, setChangeFamilyValue] = useState("");
  const [changeFamilyFlag, setChangeFamilyFlag] = useState(false);
  const [changeTargetValue, setChangeTargetValue] = useState("");
  const [changeTargetFlag, setChangeTargetFlag] = useState(false);
  const [changeSupplyDropdownValue, setChangeSupplyDropdownValue] = useState([]);
  const [changeSupplyDropdownFlag, setChangeSupplyDropdownFlag] = useState(false);
  const [targetSupplyFilterValue, setTargetSupplyFilterValue] = useState('')
  const [supplyFamilyFilterValue, setSupplyFamilyFilterValue] = useState('')
  const [isSupplyFamilyValueSame, setIsSupplyFamilyValueSame] = useState(true)
  const [isDropdownValueChange, setIsDropdownValueChange] = useState(false)
  const [showMsg, setShowMsg] = useState("");
  const [isInlineEditEnabled, setIsInlineEditEnabled] = useState(false);
  const targetSupplyRegex = "^[0-9a-zA-Z*]+(([ ]?[/\\s&][ ]?[0-9a-zA-Z()*]+)+)?$";
  const supplyFamilyRegex = "^[0-9a-zA-Z]+(([ ]?[/][ ]?[0-9a-zA-Z]+)+)?$";
  const handleIconXClick = () => {
    setIsInlineEditEnabled(!isInlineEditEnabled); // Disable inline editing
  };

  useEffect(() => {
    EncodingService.getAllSupplyCatalog().then((res) => {
      setCurrentSupplyFamilyPage(1);
      setSupplyFamilyPageSize(10);
      setSupplyFamily(res?.data);
      setCurrentSupplyFamilyDataLoading(false);
    }).catch(() => {
      removeLocalStorageItem(AUTHENTICATED);
      window.location.href = "/supplyencodingsvc/?state=Error";
    });
    EncodingService.getTargetSupplyDataAll().then((res) => {
      setCurrentTableSupplyDataPage(1);
      setTableSupplyDataPageSize(10);
      setTableSupplyData(res?.data);
      setCurrentSupplyDataLoading(false);
    }).catch(() => {
      removeLocalStorageItem(AUTHENTICATED);
      window.location.href = "/supplyencodingsvc/?state=Error";
    });
  }, []);

  useEffect(() => {
    setCurrentTableSupplyDataPage(1);
  }, [targetSupplyFilterValue, supplyFamilyFilterValue]);

  // useEffect(() => {
  //   setCurrentSupplyFamilyPage(1);
  // }, [supplyFamily]);

  const saveSupplyFamilies = async () => {
    setTarget("");
    setErrorTarget(false);
    setSelectedSupplyFamily({});
    setSelectFamilyError(false);
    if (supplyName === "") {
      showToast(<p>Please enter supply family name</p>, "error");
      setErrorSupplyName(true);
      return false;
    } else if (!supplyName.match(supplyFamilyRegex)) {
      showToast(<p>Not a valid supply family name</p>, "error");
      setErrorSupplyName(true);
      return false;
    } else {
      setErrorSupplyName(false);
    }

    const found = supplyFamily.find(
      (element) => element.family.toLowerCase() === supplyName.toLowerCase()
    );
    if (found !== undefined) {
      showToast(<p>Duplicate supply family name.</p>, "error");
      setErrorSupplyName(true);
      return false;
    }

    try {
      const addResponse = await EncodingService.addSupplyFamily({ family: supplyName });
      const addedFamily = addResponse?.data;

      if (addedFamily) {
        setSupplyFamily(prevSupplyFamily => [...prevSupplyFamily, addedFamily]);
        showToast(
          <p>
            Supply Family <span><b>{supplyName}</b></span> added successfully.
          </p>,
          "success"
        );
      }

      setErrorSupplyName(false);
      setSupplyName("");
      const catalogResponse = await EncodingService.getAllSupplyCatalog();
      setSupplyFamily(catalogResponse?.data);

    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Something went wrong, please try again';
      showToast(errorMessage, 'error');
    }

  };

  const saveTargetSupply = () => {
    setSupplyName("");
    setErrorSupplyName(false);
    let target1 = target;

    let supplyName = selectedSupplyFamily.family;
    let id1 = selectedSupplyFamily.id;

    if (target1 === "") {
      showToast(<p>Please enter target supply name</p>, "error");
      setErrorTarget(true);
      setSelectFamilyError(true);
      return false;
    }
    if (!target1.match(targetSupplyRegex)) {
      showToast(<p>Not a valid target supply name</p>, "error");
      setErrorTarget(true);
      return false;
    }
    if (supplyName !== "" && target1 !== "") {
      setErrorTarget(false);
      setSelectFamilyError(false);
    }
    if (target1.match(targetSupplyRegex)) {
      setErrorTarget(false);
    }
    if (supplyName === "" || supplyName === undefined) {
      setSelectFamilyError(true);
      showToast(<p>Select supply family</p>, "error");
      return false;
    }
    if (supplyName !== "" || supplyName !== undefined) {
      setSelectFamilyError(false);
    }

    const found = tableSupplyData.find(
      (element) => element.targetsupply.toLowerCase() === target.toLowerCase()
    );

    if (found !== undefined) {
      showToast(<p>Duplicate target supply name</p>, "error");
      setErrorTarget(true);
      setSelectFamilyError(true);
      return false;
    }

    let supplyTarget = {
      supplyfamily: supplyName,
      targetsupply: target1,
      active: 1,
      id: id1,
    };

    EncodingService.newtargetsupply(supplyTarget).then((res) => {
      let obj = res?.data;
      if (obj) {
        setTableSupplyData([...tableSupplyData, obj]);
      }
      showToast(
        <p>
          {" "}
          Target Supply{" "}
          <span>
            <b>{target1}</b>
          </span>{" "}
          added successfully.
        </p>,
        "success"
      );
      setErrorTarget(false);
      setSelectFamilyError(false);
      setTimeout(() => {
        setErrorSupplyName(false);
        setSelectFamilyError(false);
      }, 5000);

      EncodingService.getTargetSupplyDataAll().then((res) => {
        setTableSupplyData(res?.data);
      });
      setTarget("");
      setSelectedSupplyFamily({});
    }).catch((error) => {
      const errorMessage = error?.response?.data?.message || 'Something went wrong, please try again';
      showToast(errorMessage, 'error');
    });
  };

  const handleTargetSupply = (value) => {
    setSupplyName("");
    setErrorSupplyName(false);
    setTarget(value);
  };

  const handleChange = (e) => {
    setSupplyName("");
    setErrorSupplyName(false);
    let obj = {
      family: e.value,
      id: e.id,
    };
    setSelectedSupplyFamily(obj);
  };

  const handleChangeSupply = (value) => {
    setTarget("");
    setSelectedSupplyFamily({});
    setErrorTarget(false);
    setSelectFamilyError(false);
    setSupplyName(value);
  };

  const saveCheckbox = (e, id, data) => {
    let i = tableSupplyData.findIndex(item => item.id === id);
    const updatedData = [...tableSupplyData];
    updatedData[i] = {
      ...updatedData[i],
      active: e.target.checked ? "1" : "0"
    };
    setTableSupplyData(updatedData)
    let payload = { ...data, active: e.target.checked }
    EncodingService.updateCurrentSupplyActive(payload).then(
      (res) => {
        let obj = res?.data;
        if (obj) {
          EncodingService.getTargetSupplyDataAll().then((res) => {
            setTableSupplyData(res?.data);
          })
        }
        showToast(
          <p>
            {" "}
            Current supply{" "}
            <span>
              <b>{data.targetsupply}</b>
            </span>{" "}
            updated successfully.
          </p>,
          "success"
        );
      }
    ).catch((err) => {
      showToast(
        <p>
          {" "}
          Current supply{" "}
          <span>
            <b>{data.targetsupply}</b>
          </span>{" "}
          failed to update.
        </p>,
        "failure"
      );
      const revertedData = [...tableSupplyData];
      revertedData[i] = {
        ...revertedData[i],
        active: e.target.checked ? "0" : "1"
      };
      setTableSupplyData(revertedData);
    });
  };

  const handleInlineSupply = (e, i) => {
    setChangeFamilyFlag(true);
    setChangeFamilyValue(e);
  };

  const updateSupply = (e, id) => {
    let value = changeFamilyValue
    let i = supplyFamily.findIndex((item) => item.id === id)
    let obj = {
      id: id,
      family: value,
    };

    let found = 0;

    for (let j = 0; j < supplyFamily.length; j++) {
      if (
        (j !== i && supplyFamily[j].family === value) ||
        (j !== i &&
          supplyFamily[j].family.localeCompare(value, undefined, {
            sensitivity: "accent",
          }) === 0)
      ) {
        found++;
      }
    }
    EncodingService.getAllSupplyCatalog().then((res) => {
      const oldData = res?.data[i].family;
      if (
        value.match(supplyFamilyRegex) &&
        value !== "" &&
        found === 0 &&
        oldData !== value
      ) {
        EncodingService.updateSupply(obj).then((res) => {
          if (res?.data) {
            EncodingService.getAllSupplyCatalog().then((res) => {
              setSupplyFamily(res?.data)
            }).catch((error) => {
              showToast(error?.response ? error.response.data.message ? error.response.data.message : 'Something wrong, please try again' : 'error')
            })

            EncodingService.getTargetSupplyDataAll().then((res) => {
              setTableSupplyData(res?.data);
            }).catch(((error) => showToast(error?.response ? error.response.data.message ? error.response.data.message : 'Something wrong, please try again' : 'error')));
          }
          showToast("Current supply family updated successfully.", "success");
          setShowMsg("show")

        }).catch((error) => {
          showToast(error?.response ? error.response.data.message ? error.response.data.message : 'Something wrong, please try again' : 'error')
        });
      }
    }).catch((error) => {
      showToast(error?.response ? error.response.data.message ? error.response.data.message : 'Something wrong, please try again' : 'error')
    });

    const updatedData = supplyFamily.map(item =>
      item.id === id ? { ...item, family: value } : item
    );
    setSupplyFamily(updatedData);

    if (value === "") {
      showToast(<p>Please enter supply family name</p>, "error");
      EncodingService.getAllSupplyCatalog().then((res) => {
        setSupplyFamily(res?.data);
      });
    } else if (!value.match(supplyFamilyRegex)) {
      showToast(<p>Not a valid supply family name</p>, "error");
      EncodingService.getAllSupplyCatalog().then((res) => {
        setSupplyFamily(res?.data);
      });
    }
    if (found > 0) {
      showToast(<p>Duplicate supply family name</p>, "error");
      EncodingService.getAllSupplyCatalog().then((res) => {
        setSupplyFamily(res?.data);
      });
    }
    setChangeFamilyFlag(false);
  };

  const handleInlineTarget = (e) => {
    setChangeTargetFlag(true);
    setChangeTargetValue(e);
  };

  const updateTarget = (e, id) => {
    let i = tableSupplyData.findIndex(item => item.id === id);
    let value = changeTargetValue

    let obj = {
      targetSupplyName: value,
      id: id,
    };

    let found = 0;

    for (let j = 0; j < tableSupplyData.length; j++) {
      if (
        (j !== i && tableSupplyData[j].targetsupply === value) ||
        (j !== i &&
          tableSupplyData[j].targetsupply.localeCompare(value, undefined, {
            sensitivity: "accent",
          }) === 0)
      ) {
        found++;
      }
    }

    EncodingService.getTargetSupplyDataAll().then((res) => {
      const oldData = res?.data[i].targetsupply;
      if (
        value.match(targetSupplyRegex) &&
        value !== "" &&
        found === 0 &&
        oldData !== value
      ) {

        EncodingService.updateTarget(obj).then((res) => {
          if (res?.data) {
            EncodingService.getTargetSupplyDataAll().then((res) => {
              setTableSupplyData(res?.data);
            }).catch((error) => {
              const errorMessage = error?.response?.data?.message || 'Something went wrong, please try again';
              showToast(errorMessage, 'error');
            });
            showToast("Target supply updated successfully.", "success");
            setShowMsg("show")
          }
        });
      }
    });

    const updatedData = tableSupplyData.map(item =>
      item.id === id ? { ...item, targetsupply: value } : item
    );
    setTableSupplyData(updatedData);

    if (value === "") {
      showToast("Please enter target supply name", "error");
      EncodingService.getTargetSupplyDataAll().then((res) => {
        setTableSupplyData(res?.data);
      });
    } else if (!value.match(targetSupplyRegex)) {
      showToast("Not a valid target supply name", "error");
      EncodingService.getTargetSupplyDataAll().then((res) => {
        setTableSupplyData(res?.data);
      });
    }

    if (found > 0) {
      showToast("Duplicate target supply name", "error");
      EncodingService.getTargetSupplyDataAll().then((res) => {
        setTableSupplyData(res?.data);
      });
    }
    setChangeTargetFlag(false);
  };

  const handleInlineSelect = (e, id) => {
    let arr = tableSupplyData;
    let i = tableSupplyData.findIndex(item => item.id === id);
    arr[i].supplyfamily = e.target.value;
    setIsDropdownValueChange(true)
    setChangeSupplyDropdownFlag(true);
    setChangeSupplyDropdownValue([e.target.value]);
    setTableSupplyData(arr);
    setIsSupplyFamilyValueSame(false)
    let value = tableSupplyData[i].supplyfamily;

    let obj = {
      targetSupplyFamilyName: value,
      id: id,
    };

    EncodingService.updateTargetSupplyFamily(obj).then(() => {
      showToast("Target supply family updated successfully.", "success");
      setChangeSupplyDropdownFlag(false);
    }).catch((error) => {
      const errorMessage = error?.response?.data?.message || 'Something went wrong, please try again';
      showToast(errorMessage, 'error');
    });
  };

  const handleSupplyDropdownClick = () => {
    if (!isDropdownValueChange) {
      setIsSupplyFamilyValueSame(true)
    }
  }
  const handleInlineClickTarget = (event) => {
    setChangeTargetValue(event.target.firstChild?.textContent || event.target.value);
    setShowMsg("")
  }

  const handleInlineClickSupplyFamily = (event) => {
    setChangeFamilyValue(event.target.firstChild?.textContent || event.target.value);
    setShowMsg("")
  }

  const handleSupplyFamilyPageChange = (page) => {
    setCurrentSupplyFamilyPage(page);
  };

  const handleSupplyFamilyPageSizeChange = (event, option) => {
    setSupplyFamilyPageSize(option.value);
  };

  const handleTableSupplyDataPageChange = (page) => {
    setCurrentTableSupplyDataPage(page);
  };

  const handleTableSupplyDataPageSizeChange = (event, option) => {
    setTableSupplyDataPageSize(option.value);
  };

  const handleTargetSupplyFilter = (value) => {
    setTargetSupplyFilterValue(value);
    setCurrentTableSupplyDataPage(1); 
  };

  const handleSupplyFamilyFilter = (value) => {
    setSupplyFamilyFilterValue(value);
    setCurrentTableSupplyDataPage(1); 
  };

  const columns = [
    {
      id: "targetsupply",
      label: "TARGET SUPPLY",
      filter: (
        <Search
          label="Search"
          placeholder="Placeholder"
          id="table-filter-targetsupply"
          value={targetSupplyFilterValue}
          onClear={() => setTargetSupplyFilterValue('')}
          onChange={handleTargetSupplyFilter}
        />
      )
    },
    {
      id: "supplyfamily",
      label: "SUPPLY FAMILY",
      filter: (
        <Search
          label="Search"
          placeholder="Placeholder"
          id="table-filter-supplyfamily"
          value={supplyFamilyFilterValue}
          onClear={() => setSupplyFamilyFilterValue('')}
          onChange={handleSupplyFamilyFilter}
        />
      ),
    },
    {
      id: "active",
      label: "ACTIVE",
    },
  ]

  const filteredData = filterSort(
    tableSupplyData,
    {
      targetsupply: targetSupplyFilterValue,
      supplyfamily: supplyFamilyFilterValue
    }
  );

  return (
    <div>
      <Headeraccount />
      <Navigation tabsEnabledStatus={tabsEnabledStatus} role={props.role} />
      <br />
      <div className="tableWrapper">
        <div className="row  p-40">
          {/* Two columns */}
          <div className="col-md-5 col-sm-12 p-0">
            <h5 className="subtitle-large p-l-15 p-0">Add new supply family </h5>
            <br />
            <div id="supplyFamily">
              <div className="row p-l-15">
                <div className="col-md-8 p-0">
                  <ThemeProvider mode="light" shape="round" density="high">
                    <TextBox
                      density="high"
                      id="required-text-box"
                      className=""
                      name="supplyName"
                      value={supplyName}
                      onChange={(e) => handleChangeSupply(e)}
                      error={errorsupplyName}
                      placeholder="Supply family name"
                    />
                  </ThemeProvider>
                </div>
                <div className="col-md-3">
                  <Button
                    small={true}
                    id="addNewSupplyFamily"
                    className="button-p m-w-b m-t-1"
                    onClick={saveSupplyFamilies}
                  >
                    Add
                  </Button>
                </div>
              </div>

              <br />
              <br />
              <div className="d-flex flex-column">
                <h5 className="subtitle-large">Current supply families</h5>

                {/* Add a wrapper for the table */}
                <div className="col-md-12 p-0" style={{ width: "100%" }}>
                  <br />
                  <div className="table-wrapper" style={{ textAlign: "left", width: "100%" }}>
                    <Table
                      id="currentSupplyFamilyTable"
                      loading={currentSupplyFamilyDataLoading}
                      columns={[
                        {
                          id: "family",
                          label: "SUPPLY FAMILY",
                        },
                      ]}
                      data={
                        supplyFamily
                          ? supplyFamily.map((data, i) => {
                            return {
                              family: (
                                <InlineEdit
                                  text={data.family}
                                  placeholder={data.family}
                                  type="input"
                                  msg={showMsg}
                                  childRef={supplyFamilyRef}
                                  onClick={handleInlineClickSupplyFamily}
                                  onBlur={(e) => updateSupply(e, data.id)}
                                  enabled={isInlineEditEnabled}
                                >
                                  <TextBox
                                    id="required-text-box"
                                    trailingIcon={
                                      <div
                                        style={{ cursor: "pointer" }}
                                        title="Cancel value update"
                                        className="inlineY"
                                        onMouseDown={(e) => {
                                          e.preventDefault(); // Prevent the blur event
                                          handleIconXClick(); // Cancel Inline
                                        }}
                                      >
                                        <IconX />
                                      </div>
                                    }
                                    ref={supplyFamilyRef}
                                    value={
                                      changeFamilyFlag
                                        ? changeFamilyValue
                                        : data.family
                                    }
                                    onChange={(e) => handleInlineSupply(e, i)}
                                  />
                                </InlineEdit>
                              ),
                            };
                          }).slice(
                            (currentSupplyFamilyPage - 1) * supplyFamilyPageSize,
                            (currentSupplyFamilyPage - 1) * supplyFamilyPageSize + supplyFamilyPageSize
                          )
                          : null
                      }
                    />
                  </div>
                  <div
                    className="pagination-container"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginTop: "15px",
                      overflow: "auto"
                    }}
                  >
                    <Pagination
                      currentPage={currentSupplyFamilyPage}
                      pageSizeOptions={[
                        { value: 2 },
                        { value: 4 },
                        { value: 8 },
                        { value: 10 },
                        { value: supplyFamily.length },
                      ]}
                      onPageChange={handleSupplyFamilyPageChange}
                      onPageSizeChange={handleSupplyFamilyPageSizeChange}
                      totalItems={supplyFamily.length}
                      pageSize={supplyFamilyPageSize}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Two columns end */}

          <div className="col-md-7 col-sm-12">
            <h5 className="subtitle-large p-l-15">Add new target supply </h5>
            <br />
            <div id="supplyTarget">
              <div className="row p-l-15">
                <div className="col-md-4 m-w t-w-b">
                  <ThemeProvider
                    mode="light"
                    shape="round"
                    density="high"
                    id="m-w"
                  >
                    <TextBox
                      density="high"
                      id="required-text-box t-w-b"
                      className="m-w t-w-b"
                      value={target}
                      onChange={(e) => handleTargetSupply(e)}
                      error={errortarget}
                      placeholder="Target supply"
                    />
                  </ThemeProvider>
                </div>
                <span id="br-supply"></span>
                <div className="col-md-5 m-t10" id="selectSupplyFamily">
                  <ThemeProvider mode="light" shape="round" density="high">
                    <Select
                      name="selectSupplyFamily"
                      clearIcon={false}
                      value={[selectedSupplyFamily.family]}
                      placeholder={"Select supply family"}
                      onChange={handleChange}
                      options={
                        supplyFamily
                          ? supplyFamily.map((e) => {
                            return { value: e.family, id: e.id };
                          })
                          : []
                      }
                      error={selectFamilyError}
                    ></Select>
                  </ThemeProvider>
                </div>

                <div className="col-md-2">
                  <Button
                    small={true}
                    id="addNewTargetSupplyButton"
                    className="button-p m-w-b"
                    onClick={saveTargetSupply}
                  >
                    Add
                  </Button>
                </div>
              </div>
              <br />
              <br />
              <div className="row justify-content-start p-l-15">
                <h5 className="subtitle-large p-l-15">Current supplies</h5>
                <div className="col-md-12">
                  <br />
                  <Table
                    showFilters
                    id="currentSuppliesTable"
                    loading={currentSupplyDataLoading}
                    columns={columns}
                    data={
                      tableSupplyData
                        ? filteredData.map((data, i) => {
                          return {
                            targetsupply: (
                              <InlineEdit
                                text={data.targetsupply}
                                placeholder={data.targetsupply}
                                type="input"
                                childRef={targetSupplyRef}
                                onBlur={(e) => updateTarget(e, data.id)}
                                onClick={handleInlineClickTarget}
                                msg={showMsg}
                                enabled={isInlineEditEnabled}
                              >
                                <TextBox
                                  id="required-text-box"
                                  trailingIcon={
                                    <div
                                      style={{ cursor: "pointer" }}
                                      title="Cancel value update"
                                      className="inlineY"
                                      onMouseDown={(e) => {
                                        e.preventDefault();
                                        handleIconXClick(); // Clear inline edit
                                      }}
                                    >
                                      {<IconX />}
                                    </div>
                                  }
                                  ref={targetSupplyRef}
                                  value={
                                    changeTargetFlag
                                      ? changeTargetValue
                                      : data.targetsupply
                                  }
                                  onChange={(e) => handleInlineTarget(e)}
                                />
                              </InlineEdit>
                            ),
                            supplyfamily: (
                              <InlineEdit
                                text={data.supplyfamily}
                                placeholder={data.supplyfamily}
                                type="input"
                                childRef={inputRef1}
                                msg={isSupplyFamilyValueSame ? "" : "show"}
                              >
                                <select
                                  ref={inputRef1}
                                  className="inlineSelect"
                                  onClick={handleSupplyDropdownClick}
                                  onChange={(e) => handleInlineSelect(e, data.id)}
                                  value={
                                    changeSupplyDropdownFlag
                                      ? changeSupplyDropdownValue
                                      : data.supplyfamily
                                  }
                                  onBlur={() => setIsDropdownValueChange(false)}
                                >
                                  {supplyFamily.map((o) => (
                                    <option key={o.family} value={o.family}>
                                      {o.family}
                                    </option>
                                  ))}
                                </select>
                              </InlineEdit>
                            ),
                            active: (
                              <Checkbox
                                checked={Number(data?.active) === 1}
                                id={`checkbox-${data.id}`} // Make IDs unique
                                label=""
                                onChange={(e) => saveCheckbox(e, data.id, data)}
                              />
                            ),
                          };
                        }).slice(
                          (currentTableSupplyDataPage - 1) * tableSupplyDataPageSize,
                          (currentTableSupplyDataPage - 1) * tableSupplyDataPageSize + tableSupplyDataPageSize
                        )
                        : null
                    }
                  />
                  <div
                    className="pagination-container"
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginTop: "15px",
                      overflow: "auto",
                    }}
                  >
                    <Pagination
                      currentPage={currentTableSupplyDataPage}
                      pageSizeOptions={
                        filteredData.length <= 2
                          ? [{ value: filteredData.length }]
                          : filteredData.length < 5
                            ? [{ value: 2 }, { value: filteredData.length }]
                            : filteredData.length <= 8
                              ? [
                                { value: 2 },
                                { value: 4 },
                                { value: filteredData.length },
                              ]
                              : filteredData.length <= 9
                                ? [
                                  { value: 2 },
                                  { value: 4 },
                                  { value: 8 },
                                  { value: filteredData.length },
                                ]
                                : filteredData.length <= 10
                                  ? [
                                    { value: 2 },
                                    { value: 4 },
                                    { value: 8 },
                                    { value: filteredData.length },
                                  ]
                                  : [
                                    { value: 2 },
                                    { value: 4 },
                                    { value: 8 },
                                    { value: 10 },
                                    { value: filteredData.length },
                                  ]
                      }
                      onPageChange={handleTableSupplyDataPageChange}
                      onPageSizeChange={handleTableSupplyDataPageSizeChange}
                      totalItems={filteredData.length}
                      pageSize={tableSupplyDataPageSize}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SupplyCatalog;
